import { render } from "./GetHeroNavigationItem.vue?vue&type=template&id=0c963195&scoped=true"
import script from "./GetHeroNavigationItem.vue?vue&type=script&lang=js"
export * from "./GetHeroNavigationItem.vue?vue&type=script&lang=js"

import "./GetHeroNavigationItem.vue?vue&type=style&index=0&id=0c963195&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c963195"],['__file',"src/scripts/view/portfolio/common/hero/GetHeroNavigationItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0c963195"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0c963195', __exports__)) {
    api.reload('0c963195', __exports__)
  }
  
  module.hot.accept("./GetHeroNavigationItem.vue?vue&type=template&id=0c963195&scoped=true", () => {
    api.rerender('0c963195', render)
  })

}


export default __exports__